import React, { FC, PropsWithChildren, memo, useCallback } from "react";
import { useTranslation } from "react-i18next";
import AppBar from "@mui/material/AppBar";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Container from "@mui/material/Container";
import GenButton from "../GenButton/GenButton";
import GenFooter, { GenFooterProps } from "./GenFooter";
// import { useMediaQuery, useTheme } from "@mui/material";
import { BACKGROUND_COLOR } from "@ui/themes/gen-theme";
import { environment } from "@environment/environment";

interface GenLayoutProps {
  showFooter?: boolean;
  footer?: GenFooterProps;
  disableLanguageSwitcher?: boolean;
}

const GenLayout: FC<PropsWithChildren<GenLayoutProps>> = (props) => {
  const {
    children,
    showFooter = false,
    footer,
    disableLanguageSwitcher = false,
  } = props;
  const { t, i18n } = useTranslation();
  // const theme = useTheme();
  // const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const handleSelect = useCallback(
    async (eventKey: string): Promise<void> => {
      await i18n.changeLanguage(eventKey);
    },
    [i18n],
  );

  return (
    <Container
      maxWidth={false}
      sx={{
        backgroundColor: BACKGROUND_COLOR,
      }}
    >
      <AppBar
        position="fixed"
        sx={{
          backgroundColor: "white",
          boxShadow: "0px 2px 4px -1px rgba(0,0,0,0.2)",
        }}
      >
        <Box
          display="flex"
          justifyContent="space-between"
          alignItems="center"
          paddingTop={2}
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyItems: "center",
              alignItems: "center",
              marginLeft: 2,
              padding: 2,
            }}
          >
            <img
              src={`${environment.publicPath}/images/generali-logo-horizontal-red.svg`}
              alt="Generali Logo"
              height="24px"
              width="171px"
            />
          </Box>

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyItems: "center",
              alignItems: "center",
              marginRight: 2,
              gap: 1,
            }}
          >
            {!disableLanguageSwitcher ? (
              <>
                <GenButton
                  variant="text"
                  color={i18n.language === "en" ? "primary" : "secondary"}
                  onClick={async () => {
                    await handleSelect("en");
                  }}
                  sx={{
                    minWidth: 0,
                    padding: 0,
                  }}
                >
                  {t("lang_en")}
                </GenButton>
                <Typography>{"|"}</Typography>
                <GenButton
                  variant="text"
                  color={i18n.language === "th" ? "primary" : "secondary"}
                  onClick={async () => {
                    await handleSelect("th");
                  }}
                  sx={{
                    minWidth: 0,
                    padding: 0,
                  }}
                >
                  {t("lang_th")}
                </GenButton>
              </>
            ) : null}
          </Box>
        </Box>
      </AppBar>
      <Box sx={{ minHeight: "90vh", paddingTop: 12 }}>
        <Grid
          container
          justifyContent="center"
          // alignContent="center"
          minHeight="90vh"
        >
          <Grid size={{ sm: 12, md: 6, xl: 4 }}>{children}</Grid>
        </Grid>
      </Box>
      {showFooter ? <GenFooter {...footer} /> : null}
    </Container>
  );
};

export default memo(GenLayout);
